import { SearchProduct } from '@winelivery-org/wl-client-sdk-js/dist/models/search';
import { Upload as IconShare } from '../../../../../components/icons';
import { Button } from '../../../../../components/design-system';
import ShareModal from './ShareModal';

interface Props {
  product: SearchProduct;
}

export default function ButtonShare({ product }: Props) {
  return (
    <ShareModal
      product={product}
      renderTrigger={({ open }) => (
        <Button
          className="shrink-0"
          size="lg"
          variant="icon"
          theme="outline"
          onClick={open}
        >
          <IconShare />
        </Button>
      )}
    />
  );
}
